// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

import PageLayer from "@/Layouts/views/PageLayer";
import AdvisorWashoutLayer from "@/Washouts/views/Layers/Advisors/AdvisorWashoutLayer";
import actionsList from "@Constants/actionsList";
import { supportedSystemPositions } from "@/Common/helpers/Positions";

const positions = supportedSystemPositions();
const POSITION = positions.SERVICE.SERVICE_ADVISOR;

export default function ServiceAdvisorWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_SERVICE_ADVISOR_COMPENSATION,
	};

	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<AdvisorWashoutLayer position={POSITION} actions={actions} positionType={"Producer"} />
		</PageLayer>
	);
}
